module.exports = __webpack_public_path__ + "static/media/add_blue.8e54e268.svg";